// import Vue from "vue";
import Vue from "vue";
import VueRouter from "vue-router";
// import { createRouter, createWebHistory } from 'vue-router'
// import Login from './components/authentification/Login.vue'
// import Signup from './components/authentification/Signup.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/prepaiement/:restaurant',
    name: 'Prepaiement',
    component: () => import("./components/Plan.vue")
  },
  {
    path: '/client',
    name: 'Client',
    component: () => import("./components/progfidelite/Compte_salon.vue")
  }
  ,
  {
    path: '/reservations/table/:restaurant',
    name: 'Plan',
    component: () => import("./components/PlanResa.vue")
  },
  {
    path: '/reservations/:restaurant',
    name: 'Plan',
    component: () => import("./components/Plan.vue")
  },
  
  {
    path: '/reservations99/:restaurant',
    name: 'Plan',
    component: () => import("./components/Plan99.vue")
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import("./components/authentification/Login.vue")
  },
  {
    path: '/signup',
    name: 'Signup',
    component: () => import("./components/authentification/Signup.vue")

    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    //component: () => import(/* webpackChunkName: "about" */ './components/authentification/Signup.vue')
  },
  // {
  //   path: '/compte',
  //   name: 'Compte',
  //   component: () => import("./components/progfidelite/Compte.vue")
  // },
  {
    path: '/historique',
    name: 'Historique',
    component: () => import("./components/progfidelite/Historique_salon.vue")
  },
  // {
  //   path: '/historique',
  //   name: 'Historique',
  //   component: () => import("./components/progfidelite/Historique.vue")
  // },
  {
    path: '/:restaurant/:menu/:table?',
    name: 'Menu',
    component: () => import("./components/index.vue")
  }
 
]
// const router = createRouter({
//   history: createWebHistory(process.env.BASE_URL),
//   routes
// })

const router = new VueRouter({
  mode: "history",
  routes
})
export default router;